export default function initCaptchaOnForm(
  formClass,
  submitBtnClass,
  captchaContainerId
) {
  const CLIENT_KEY = "ysc1_IhGd7wBe0alL7zFaaEhNlKiDXD0FtOktef4jllLi806d10ff";

  const form = document.querySelector(formClass);
  const captchaContainer = document.getElementById(captchaContainerId);
  const submitBtn = document.querySelector(submitBtnClass);

  if (!form || !captchaContainer || !submitBtn) {
    return;
  }

  let smartLoaded = false;
  let widgetId = null;

  function onSmartLoad() {
    smartLoaded = true;
    renderCaptcha();
  }

  if (window.smartCaptcha && typeof window.smartCaptcha.render === "function") {
    onSmartLoad();
  }

  function renderCaptcha() {
    if (!smartLoaded) {
      return;
    }

    try {
      widgetId = window.smartCaptcha.render(captchaContainer, {
        sitekey: CLIENT_KEY,
      });
    } catch (err) {}

    let existing = form.querySelector('input[name="smart-token"]');

    if (existing) {
      if (existing.type !== "hidden") {
        existing.required = true;
        existing.classList.add("sr-only");
      }

      try {
        existing.type = "text";
      } catch (err) {
        const repl = document.createElement("input");
        repl.type = "text";
        repl.name = existing.name;
        repl.required = true;
        repl.classList.add("sr-only");
        existing.parentNode.replaceChild(repl, existing);
        existing = repl;
      }

      existing.required = true;
      existing.classList.add("sr-only");
    }

    // Если не найден — создаём input type=text required sr-only с именем smart-token
    // const tokenInput = document.createElement("input");
    // tokenInput.type = "text";
    // tokenInput.name = "smart-token";
    // tokenInput.required = true;
    // tokenInput.classList.add("sr-only");
    // // Добавим в конец формы (или туда, где вам удобно)
    // form.appendChild(tokenInput);
    // return tokenInput;
  }

  function resetCaptcha() {
    captchaContainer.innerHTML = "";
    widgetId = null;

    setTimeout(() => {
      renderCaptcha();
    }, 250);
  }

  try {
    form.addEventListener("submit", (event) => {
      event.preventDefault();

      const tokenInputs = document.getElementsByName("smart-token");

      if (!tokenInputs || !tokenInputs.length) {
        return;
      }

      const tokenInputValue = Object.values(tokenInputs).find(
        (input) => input.value
      );

      if (!tokenInputValue) {
        return;
      }

      resetCaptcha();
    });
  } catch (error) {
    resetCaptcha();
  }
}
